import { Component, ViewChild, ElementRef } from '@angular/core';
import { HttpResponse, HttpEventType } from '@angular/common/http';
import { FormControl, FormGroup, Validators, FormArray, ValidatorFn, AbstractControl } from '@angular/forms';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { AdministrationService } from './administration.service';
import { ConfirmService } from '../shared/confirm/confirm.service';
import { AppService } from '../app.service';
import { Globals } from '../globals';
import translateJson from "../../translate.json";
import customerJson from "../../assets/config/customer.json";
import { DateUpdateFix } from '../models/date-update-fix';
import { AuthenticationService } from '../auth';


@Component({
    selector: 'administration-comp',
    providers: [AdministrationService, AppService, ConfirmService, DateUpdateFix, AuthenticationService],
    templateUrl: './administration.component.html',  
    styleUrls: ['./administration.component.css']  
})

export class AdministrationComponent {

  
  // Get translation/text from customerJson
  private i18 = translateJson.i18;

  private edition = customerJson.edition;
  private activeComponent: boolean;
  private pageType: any;
  private disableAddGroupBtn: boolean = false;
  private groupsList: any = [];
  private currentGroup: any;
  private modalType = '';
  editGroupModalReady:boolean = false;
  renameGroup: boolean = false;
  filteredUser: String;
  private userList: any = [];
  private ownerList: any = [];
  private addMemberList: any = [];
  private addOwnerList: any = [];
  private displayAddMemberList: any = [];
  private memberList: any = [];

  private removeMemberList: any = [];
  private removeOwnersList: any = [];

  personSearchForm: FormGroup;
  groupSearchForm: FormGroup;
  groupAddForm: FormGroup;
  groupEditForm: FormGroup;

  constructor(
    private service: AdministrationService,
    private appService: AppService,
    private confirmService: ConfirmService,
    private ngxSmartModalService: NgxSmartModalService,
    private dateUpdateFix: DateUpdateFix,
    private globals: Globals,
    private authService: AuthenticationService
  ) {
    this.authService.isAuthenticated();
    this.activeComponent = appService.isComponentActive('administration');
    this.setDefault();
  }

  /**
   * Initiate all fields and prepare forms
   */
  setDefault() {
    this.pageType = "person";

    this.personSearchForm = new FormGroup({
      person: new FormControl(),
      groups: new FormControl(),
      status: new FormControl(),
      amountPerPage: new FormControl()
    }); 

    this.groupSearchForm = new FormGroup({
      searchGroup: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(255)]),
      groupName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(255)]),
      amountPerPage: new FormControl()
    });

    this.groupEditForm = new FormGroup({
      groupName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(255)])
    });
    this.findListMembers();
  }

  /**
   * Get all groups from database
   */
  getAllGroups(){
    this.service.getAllGroups().subscribe(
      data => this.patchGroupsList(data),
      error => this.showError(error.error)
    )
  }

  /**
   * Set the groups to be displayed on the main group page
   * @param data group data
   */
  patchGroupsList(data){
    this.groupsList = data;
  }

  /**
   * Switch page type 
   * @param pageType (person, groups)
   */
  setPageTypeView(pageType) {
    this.pageType = pageType;
    if(pageType === 'person'){
      this.findListMembers();
    }

    else if(pageType === 'groups'){
      this.getAllGroups();
    }
  }

  /**
   * Save the group to database
   */
  addGroup(){
    this.service.addGroup(this.groupSearchForm.value).subscribe(
      data => {
        this.patchGroupsList(data)
        this.groupSearchForm.patchValue({
          groupName: ''
        });
      }, error => this.showError(error)
    );

  }

  /* Error modal on employer creation */
  showError(error) {
    this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
  }

  /**
   * Edit existing group
   */
  editGroup(group){
    this.modalType = 'editGroup';
    this.groupEditForm.patchValue({groupName:group.groupName});
    this.ngxSmartModalService.setModalData(group, 'editGroupModal', true);
    this.ngxSmartModalService.getModal('editGroupModal').open();
    this.editGroupModalReady = true;
  }

  /**
   * Remove existing group
   */
  removeGroup(group){
    let confirmMsg = this.i18.modals.confirmModal.deleteGroupConfirmMsg + group.groupName + this.i18.modals.confirmModal.deleteGroupWarningMsg;
    this.confirmService.confirm(confirmMsg)
      .then(result => {
        if(result) {
          this.service.deleteGroup(group.id).subscribe(
            data => {
              this.patchGroupsList(data)
            }, error => this.showError(error)
          );
        }
      });
  }

  /**
   * Edit group members (persons)
   */
  showEditGroupMembers(group){
    this.pageType = 'editGroupMembers';
    this.currentGroup = group;

  }

  /**
   * Update the group and remove the selected owners from it
   * @param groupId current group uuid
   */
  removeGroupOwners(groupId){
    let confirmMsg = 'Vill du verkligen ta bort gruppägarna från gruppen?'
    this.confirmService.confirm(confirmMsg)
      .then(result => {
        if(result) {
          this.service.removeGroupOwners(groupId, this.removeOwnersList).subscribe(
            data => {
              this.updateCurrentGroup(data), 
              this.removeOwnersList = []
            },
            error => this.showError(error)
          );
        }
      });
  }

  /**
   * Save the selected group members
   * @param groupId current group uuid
   */
  addGroupOwners(groupId){
    this.service.addGroupOwners(groupId, this.addOwnerList).subscribe(
      data => {
        this.updateCurrentGroup(data), 
        this.addOwnerList = []
      },
      error => this.showError(error)
    );

  }

  /**
   * Update the group and remove the selected members from it
   * @param groupId current group uuid
   */
  removeGroupMembers(groupId){
    let confirmMsg = 'Vill du verkligen ta bort personerna från gruppen?';
    this.confirmService.confirm(confirmMsg)
      .then(result => {
        if(result) {
          this.service.removeGroupMembers(groupId, this.removeMemberList).subscribe(
            data => {
              this.updateCurrentGroup(data),
              this.removeMemberList = []
              },
            error => this.showError(error)
          );
        }
      });
  }

  /**
   * Switch show rename filed boolean by button klick
   */
  showRenameFields(){
    this.renameGroup = !this.renameGroup;
  }

  /**
   * Perform updates triggerd in the editGroupModal
   * @param group group object
   */
  updateGroup(group){
    if(this.renameGroup){
      let newGroupName = this.groupEditForm.get('groupName').value;
      this.service.updateGroup(group.id, newGroupName).subscribe(
        data => {group.groupName = newGroupName, this.patchGroupsList(data)},
        error => this.showError(error)
      );
    }
  }

  /**
   * Clear the edit form and close the editGroupModal Modal
   */
   closeEditGroupModal(){
    this.renameGroup = false;
    this.groupEditForm.patchValue({groupName:''});
    this.ngxSmartModalService.getModal('editGroupModal').close();
    this.editGroupModalReady = false;
  }
  
  /**
   * Save the selected group members
   * @param groupId current group uuid
   */
  addGroupMembers(groupId){
    this.service.addGroupMembers(groupId, this.addMemberList).subscribe(
      data => {
        this.updateCurrentGroup(data), 
        this.addMemberList = []
        this.displayAddMemberList = []
      },
      error => this.showError(error)
    );
  }

  /**
   * Helper to patch the datestamps fo backend compabillity
   * @param list list of group members
   * @returns updated list
   */
  fixGroupMemberDates(list, type){
    if(type === 'member'){
      list.forEach(member => {
        member.createdDate = ((member.createdDate === null || member.createdDate === "") ? null : this.dateUpdateFix.fixDateOnUpdate(member.createdDate));
        member.lastUpdatedDate = ((member.lastUpdatedDate === null || member.lastUpdatedDate === "") ? null : this.dateUpdateFix.fixDateOnUpdate(member.lastUpdatedDate));
      });
    } else if(type === 'owner'){
      list.forEach(owner => {
        owner.addedDate = ((owner.addedDate === null || owner.addedDate === "") ? null : this.dateUpdateFix.fixDateOnUpdate(owner.addedDate));
        owner.updatedDate = ((owner.updatedDate === null || owner.updatedDate === "") ? null : this.dateUpdateFix.fixDateOnUpdate(owner.updatedDate));
      });
    }
    return list;
  }

  /**
   * Method to populate the add group person modal
   * @param group the currently viewed group
   */
  findGroupMembers(group){
    this.modalType = 'findGroupMembers';
    this.ngxSmartModalService.setModalData(group, 'editGroupModal', true);
    this.ngxSmartModalService.getModal('editGroupModal').open();
    this.editGroupModalReady = true;
    this.service.getPersonsNotInGroup(group.id).subscribe(
      data => {
        this.setUserList(data)
      }, error => this.showError(error)
    );
  }

  /**
   * Open the modal used to adding group owners
   * @param group current group
   */
  findGroupOwners(group){
    this.modalType = 'findGroupOwners';
    this.ngxSmartModalService.setModalData(group, 'editGroupModal', true);
    this.ngxSmartModalService.getModal('editGroupModal').open();
    this.editGroupModalReady = true;
    this.service.getAllOwners(group.id).subscribe(
      data => this.setOwnerList(data),
      error => this.showError(error)
    )

  }

  findListMembers(){
   
    this.service.getALLGroupMembers().subscribe(
      data => this.setMemberList(data),
      error => this.showError(error)
    )

  }
  /**
   * Set the group members userlist
   */
  setUserList(users){
    this.userList = users;
  }

  setOwnerList(owners){
    this.ownerList = owners;
  }

  setMemberList(members){
    this.memberList = members;
  }

  /**
   * Adds a person to the list of persons to be added to the group
   * @param event true/false
   * @param person person to add/remove to list
   */
  addPersonToGroupList(event, person) {
    let personStr = person.lastName + ' ' + person.firstName + ' (' + person.ssn + ')';
    if(event && !this.addMemberList.find(memberId => memberId === person.id)){
      this.addMemberList.push(person.id);
    }
    else if(!event && this.addMemberList.find(memberId => memberId === person.id)){
      this.addMemberList.pop(person.id);
    }
    if(event && !this.addMemberList.find(memberStr => memberStr === personStr)){
      this.displayAddMemberList.push(personStr);
    }
    else if(!event && this.addMemberList.find(memberId => memberId === personStr)){
      this.displayAddMemberList.pop(personStr);
    }
  }

  /**
   * Adds a owner to the list of persons to be added to the group
   * @param event true/false
   * @param owner person to add/remove to list
   */
   addOwnerToGroupList(event, owner) {
    if(event && !this.addOwnerList.find(member => member.userName === owner.userName)){
      this.addOwnerList.push(owner);
    }
    else if(!event && this.addOwnerList.find(member => member.userName === owner.userName)){
      this.addOwnerList.pop(owner);
    }
  }

  /**
   * Helper to update the current group viewed
   * @param data group data
   */
  updateCurrentGroup(data){
    this.currentGroup = data;
  }

}
